import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getSetupStatus,
  dismissChecklist,
  reopenChecklist,
  markCompletionSeen,
  markItemNotApplicable,
  markItemApplicable,
} from '../services/setup-status-api';

export const SETUP_STATUS_QUERY_KEY = ['company', 'setup-status'];

export function useSetupStatus() {
  return useQuery({
    queryKey: SETUP_STATUS_QUERY_KEY,
    queryFn: getSetupStatus,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}

export function useDismissChecklist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: dismissChecklist,
    onSuccess: () => qc.invalidateQueries({ queryKey: SETUP_STATUS_QUERY_KEY }),
  });
}

export function useReopenChecklist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: reopenChecklist,
    onSuccess: () => qc.invalidateQueries({ queryKey: SETUP_STATUS_QUERY_KEY }),
  });
}

export function useMarkCompletionSeen() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: markCompletionSeen,
    onSuccess: () => qc.invalidateQueries({ queryKey: SETUP_STATUS_QUERY_KEY }),
  });
}

export function useMarkItemNotApplicable() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (itemId: string) => markItemNotApplicable(itemId),
    onSuccess: () => qc.invalidateQueries({ queryKey: SETUP_STATUS_QUERY_KEY }),
  });
}

export function useMarkItemApplicable() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (itemId: string) => markItemApplicable(itemId),
    onSuccess: () => qc.invalidateQueries({ queryKey: SETUP_STATUS_QUERY_KEY }),
  });
}
